import React, { useEffect, useState } from 'react';
import './style.modules.css';
import logo from '../../assets/img/Sobr.png';
import couple from '../../assets/ambassadors/couple.png';
import world from '../../assets/ambassadors/world.png';
import asian2 from '../../assets/ambassadors/asian2.png';
import arrow from '../../assets/img/arrow.svg';
import vector5 from '../../assets/ambassadors/Vector5.svg';
import midias from '../../assets/img/Social Media.svg';
import vector10 from '../../assets/ambassadors/vector10.svg';
import vector11 from '../../assets/ambassadors/Vector11.svg';
import vector12 from '../../assets/ambassadors/Vector12.svg';
import Navbar from '../../components/navbares';
import vector7 from '../../assets/ambassadors/Vector7.svg';
import vector6 from '../../assets/img/Vector6.png';
import { useNavigate } from 'react-router-dom';

function Ambassadors() {


    // Função para rolar até o menu principal
    const scrollToMenu = () => {
        const menuElement = document.querySelector('.logo'); // Seleciona o primeiro elemento com a classe 'logo'
        if (menuElement) {
            menuElement.scrollIntoView({ behavior: 'smooth' });
        }
    };
        return (
<>
        < Navbar/>
    <header>
        <nav>
            <div className="logo">
                <img src={logo} height="36" width="78" alt="logo" title="logo"/>
            </div>
        </nav>
    </header>
    <body>

                <img className="shade" src={vector5} alt="shade" title="shade"/>
                <img className="couple" src={couple} alt="couple" title="couple" height="450px" width="400px"/>
                <div className='couple-border'></div>
            <main>
                <section className="hero">
                    <div className="content">
                        <h1>Embajadores de Sobr</h1>
                        <p>Nuestros Embajadores de Sobr son los corazones y las mentes detrás de la revolución de la felicidad en Sobr. Como apasionados defensores de la sobriedad, encarnan los valores de autenticidad, salud y conexiones genuinas que hacen que Sobr sea único.
                        </p>
                    </div>
                </section>
            </main>
{/*         <div className="form-container">
            <h2 className="form-title">Titulo</h2>
        <form>
            <div className="input-container">
                <input type="text" name="name" placeholder="Name" />
            </div>
            <div className="input-container">
                <input type="email" name="email" placeholder="Email" />
            </div>
            <div className="input-container">
                <input type="text" name="whatsapp" placeholder="Whatsapp" />
            </div>
            <div className="input-container">
                <input type="text" name="instagram" placeholder="Instagram" />
            </div>
        <button type="submit" className="submit-button">Enviar</button>
        </form>
    </div> */}
    <div className="world">
        <img src={world} alt="world" title="world" height="400" width="450"/>
    </div>
    <div className="content2">
        <h1>Lo que hacen nuestros Embajadores</h1>
        <p> <strong>Inspirar:</strong> Nuestros embajadores comparten sus historias personales de transformación y crecimiento, inspirando a otros a abrazar la sobriedad como un estilo de vida positivo y gratificante.
<strong>Conectar: </strong>Son constructores de puentes, uniendo a las personas y las comunidades en torno a la misión de Sobr para crear un mundo más feliz y más saludable, libre del estigma asociado con la sobriedad.
<strong>Educar:</strong>  Nuestros embajadores son educadores comprometidos, proporcionando valiosos recursos e información sobre los beneficios de la sobriedad y el apoyo disponible en la comunidad Sobr.
</p>
    </div>
    <img className="asian3" src={asian2} alt="couple" title="couple"/>
    <div className="content3">
        <h1>Por qué ser Embajador:</h1>
        <p> <strong>Impacto:</strong> Sea parte de una comunidad global que está cambiando vidas y desafiando las percepciones sobre la sobriedad. Como Embajador, usted tendrá la oportunidad de hacer una diferencia significativa en la vida de otras personas.
<br></br> <strong>Apoyo:</strong> Recibir apoyo del equipo de Sobr y otros embajadores mientras navegas tu propio viaje de sobriedad y ayudas a otros en el suyo.
<strong>Reconocimiento:</strong> Serás reconocido como líder de opinión y defensor de la sobriedad, aparecerás en nuestras plataformas y eventos, y formarás parte de una red exclusiva de embajadores globales.
        </p>
    </div>
{/*     <div className="content7">
        <h1>What our happy customers are saying</h1>
    </div>
    <div className="review-box">
        <div className="header">
            <h3>Margie V.</h3>
            <p>Montevideo</p>
        </div>
    <div className="starx">
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="time">2 months ago</span>
    </div>
    <div className="content">
        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
    </div>
    <div className="verified">
        <span>Verified by</span>
    </div>
    </div>
    <div className="review-box">
        <div className="header">
            <h3>Margie V.</h3>
            <p>Montevideo</p>
        </div>
    <div className="starx">
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="time">2 months ago</span>
    </div>
    <div className="content">
        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
    </div>
        <div className="verified">
            <span>Verified by</span>
        </div>
        </div>  
        <div className="review-box">
            <div className="header">
                <h3>Margie V.</h3>
                <p>Montevideo</p>
        </div>
        <div className="starx">
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="time">2 months ago</span>
        </div>
            <div className="content">
                <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
            </div>
            <div className="verified">
                <span>Verified by</span>
            </div> 
            </div> */}
            <div className="shade2" style={{ backgroundImage: `url(${vector6})` }}>
            </div>
            <div className="midias">           
                <img className="midias" src={midias} height="24" width="260" alt="mídias" title="mídias"/>
            </div>
            <footer>
                <div className="footer-content">
                    <p>Termos de Servicio | Política de Privacidad</p> 
                </div>
                <div className="footer-copyright">
                &copy; 2024 Sobr Inc., Todos los Derechos Reservados   
                </div>
                {/* Ícone da seta para rolar até o menu principal */}
                <div onClick={scrollToMenu} style={{ cursor: 'pointer', marginTop: '20px' }}>
                    <img src={arrow} height="24" width="24" alt="scroll to top" title="scroll to top"/>
                </div>
            </footer>
        </body> 
</>
)
    }
    
export default Ambassadors;